var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeedbackHasViolationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.25a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zm0 10a.626.626 0 110-1.251.626.626 0 010 1.251zm.625-3.225v.725a.625.625 0 01-1.25 0V7.5a.625.625 0 01.625-.625.937.937 0 10-.938-.938.625.625 0 01-1.25 0 2.188 2.188 0 112.813 2.088z",
    fill: "#6AC2A0"
  })));
}

export default SvgFeedbackHasViolationIcon;